export const PLAN_LIMITS = {
  Free: 1,
  Start: 10,
  Scale: 50,
  Pro: "unlimited",
};

export const PLAN_LABELS = {
  Free: "Free",
  Start: "Start",
  Scale: "Scale",
  Pro: "Pro",
};
